import styles from './SummaryCard.module.css';
import { useTranslation } from 'react-i18next';
import { ReactComponent as SearchSVG } from '@Assets/svg/userSearch.svg';
import { ReactComponent as CarSVG } from '@Assets/svg/car2.svg';
import { ReactComponent as DealSVG } from '@Assets/svg/doneDeal.svg';
import { useState } from 'react';
import SummaryCardDetail from '../SummaryCardDetail';

interface SummaryCardProps {
	className?: string;
}

const SummaryCard = ({ className = '' }: SummaryCardProps) => {
	const { t } = useTranslation();
	const [openDetails, setOpenDetails] = useState<number | null>(null);

	return (
		<div className={`${className} ${styles.container}`}>
			<div className={styles.title}>{t('summaryCards.title')}</div>
			<div className={styles.steps_container}>
				<div className={styles.step_container} onClick={() => setOpenDetails(1)}>
					<div className={styles.border_glow}></div>
					<div className={styles.card_inner_content}>
						<CarSVG className={styles.card_img} />
						<div className={styles.card_content}>
							<div className={styles.step_title}>{t('summaryCards.step2Title').toUpperCase()}</div>
							<div className={styles.step_description}>
								<p>{t('summaryCards.step2Desc')}</p>
							</div>
						</div>
					</div>
				</div>

				<div className={styles.step_container} onClick={() => setOpenDetails(2)}>
					<div className={styles.border_glow}></div>
					<div className={styles.card_inner_content}>
						<SearchSVG className={styles.card_img} />
						<div className={styles.card_content}>
							<div className={styles.step_title}>{t('summaryCards.step1Title').toUpperCase()}</div>
							<div className={styles.step_description}>
								<p>{t('summaryCards.step1Desc')}</p>
							</div>
						</div>
					</div>
				</div>

				<div className={styles.step_container} onClick={() => setOpenDetails(3)}>
					<div className={styles.border_glow}></div>
					<div className={styles.card_inner_content}>
						<DealSVG className={styles.card_img} />
						<div className={styles.card_content}>
							<div className={styles.step_title}>{t('summaryCards.step3Title').toUpperCase()}</div>
							<div className={styles.step_description}>
								<p>{t('summaryCards.step3Desc')}</p>
							</div>
						</div>
					</div>
				</div>
			</div>

			<SummaryCardDetail stepId={openDetails} isOpen={openDetails !== null} onCancel={() => setOpenDetails(null)} />
		</div>
	);
};

export default SummaryCard;
